module.exports = __webpack_public_path__ + "static/media/cv.20a8cfff.svg";